import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { useScreen } from "../../core/Global";

type Props = React.HTMLAttributes<HTMLDivElement>;

export default function ScrollContainer(props: Props) {
    const { children, className = "", ...rest } = props;
    const screen = useScreen()
    const location = useLocation()

    const [height, heightSet] = useState(0)

    useEffect(() => {

        const measure = () => {
            var h = screen.heightDoc;
            const pageTitleBar = document.getElementById("kt-page-title-bar");
            if (pageTitleBar) {
                h -= pageTitleBar.offsetHeight;
            }
            heightSet(h);
        };

        measure();

        const pageTitleBar = document.getElementById("kt-page-title-bar");
        let observer: ResizeObserver | undefined;
        if (pageTitleBar && typeof ResizeObserver !== "undefined") {
            observer = new ResizeObserver(() => measure());
            observer.observe(pageTitleBar);
        }

        return () => {
            observer?.disconnect();
        };

    }, [screen.heightDoc, location.pathname])

    return (
        <SimpleBar
            className={className}
            style={{ height: height }}
            autoHide
        >
            {children}
        </SimpleBar>
    );
}
